<template>
    <div class="main-wrapper">
        <layout-header />

        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
                        </div>
                    </div>

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div v-if="currentUser.role === 'owner' && !establishment.is_verified" class="alert alert-warning alert-dismissible fade show my-5 text-center" role="alert">
                            <h4 class="alert-heading">Établissement en attente de vérification</h4>
                            <p>Contact the manager to receive the necessary steps to complete this procedure.</p>
                        </div>

                        <div v-else>
                            <div class="d-block d-sm-flex justify-content-between align-items-center border-bottom mb-3">
                                <h2>Mon Espace</h2>
                                <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                    <li class="nav-item">
                                        <a class="nav-link" :class="{ active: activeTab === 'infos' }"
                                            @click="this.activeTab='infos'" href="javascript:void(0)">Infos</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" :class="{ active: activeTab === 'facilities' }"
                                            @click="this.activeTab='facilities'" href="javascript:void(0)">Terrains</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" :class="{ active: activeTab === 'business_hours' }"
                                            @click="this.activeTab='business_hours'" href="javascript:void(0)">Horaires</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" :class="{ active: activeTab === 'other_infos' }"
                                            @click="this.activeTab='other_infos'" href="javascript:void(0)">Autres</a>
                                    </li>
                                    <!-- <li class="nav-item">
                                        <a class="nav-link" :class="{ active: activeTab === 'photos' }"
                                            @click="this.activeTab='photos'" href="javascript:void(0)">Photos</a>
                                    </li> -->
                                </ul>
                            </div>

                            <div class="tab-content pt-0 mb-5">
                            <div v-if="activeTab === 'infos'" class="tab-pane fade show active">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group card-label mb-3">
                                            <label>Nom de l'espace</label>
                                            <input type="text" class="form-control" :readonly="currentUser.role === 'owner'"
                                                v-model="establishment.business_name" required/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex flex-row align-items-center mt-1 mb-3">
                                            <img :src="previewUrl || defaultImage" class="mr-3" style="width: 70px;" />
                                            <label class="btn btn-primary text-sm rounded-pill mr-3 mb-0">
                                                <b class="text-xs d-flex align-items-center">
                                                    <i class="material-symbols-outlined text-sm mr-1">upload</i>
                                                    Importer votre logo
                                                </b>
                                                <input type="file" class="d-none" @change="handleFileUpload"
                                                    accept="image/*">
                                            </label>
                                            <div class="text-muted">
                                                <p class="text-xs m-0">Allowed JPG, JPEG or PNG.</p>
                                                <p class="text-xs m-0">Max size of 2MB.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row h-100">
                                    <div class="col-md-6">
                                        <div class="form-group card-label mb-3">
                                            <label>Adresse</label>
                                            <input type="text" class="form-control" v-model="establishment.address"
                                                disabled />
                                        </div>
                                        <div class="form-group card-label mb-3">
                                            <label>Délégation</label>
                                            <input type="text" class="form-control" v-model="establishment.delegation"
                                                disabled />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <GoogleMap class="my-2 rounded-lg overflow-hidden" :center="mapCenter" :zoom="18" :options="{
                                            mapTypeId: 'hybrid',
                                        }" style="width: 100%; height: 175px" />
                                    </div>
                                </div>
                                <div class="row h-100">
                                    <div class="col-md-6">
                                        <div class="form-group card-label mb-3">
                                            <label>Email</label>
                                            <input type="email" class="form-control" v-model="establishment.email" required :disabled="true"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group card-label mb-3">
                                            <label>Matricule Fiscale</label>
                                            <input type="text" class="form-control border-0"
                                                v-model="establishment.vat_id" required />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 h-100">
                                        <div class="form-group card-label h-100 mb-3">
                                            <label>Description</label>
                                            <textarea type="text" class="form-control" rows="3"
                                                v-model="establishment.description"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit-section d-flex gap-3">
                                    <button type="submit" class="btn btn-primary btn-rounded text-sm" @click.prevent="saveInfos">
                                        <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                        <label class="m-0 mx-1">Enregistrer</label>
                                    </button>
                                    <button type="button" class="btn btn-rounded text-sm mx-1 btn-success" v-if="!establishment.is_verified && currentUser.role === 'admin'" @click.prevent="validateEstablishment">
                                        <label class="m-0 mx-1">Valider</label>
                                    </button>
                                    <button type="button" :class="['btn', 'btn-rounded', 'text-sm mx-1', establishment.is_active ? 'btn-danger' : 'btn-success']" @click.prevent="toggleEstablishmentStatus" v-if="establishment.is_verified">
                                        <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                        <label class="m-0 mx-1">{{ establishment.is_active ? 'Désactiver' : 'Activer' }}</label>
                                    </button>
                                </div>
                            </div>
                            <div v-if="activeTab === 'facilities'" class="tab-pane fade show active">
                                <div class="row" v-if="facilities.length > 0">
                                    <div class="col-lg-3 col-md-4 col-sm-6" v-for="facility in facilities">
                                        <a class="" :href="'/my/establishment/facility/'+facility.id">
                                            <div class="border bg-white d-flex flex-column rounded-xl overflow-hidden h-100">
                                                <div class="overflow-hidden position-relative" style="height: 8rem;">
                                                    <img :src="getFeaturedImage(facility) || defaultImage"
                                                        class="w-100 h-100 object-cover" loading="lazy">
                                                    <div class="bg-white position-absolute inset-top-left rounded-lg overflow-hidden d-flex justify-content-center align-items-center p-2"
                                                        style="width: 60px; height: 60px;">
                                                        <img :src="previewUrl || defaultImage" class="w-100">
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-start px-3 pt-3">
                                                    <p class="overflow-hidden whitespace-nowrap">Terrain {{ facility.sport_type }} {{ facility.location_type }} - {{ facility.name }}</p>
                                                </div>
                                                <div class="d-flex justify-content-start px-3 pb-3">
                                                    <p class="text-sm text-muted overflow-hidden whitespace-nowrap">{{ this.establishment.business_name }}</p>
                                                </div>
                                                <!-- <div class="d-flex text-dark justify-content-start px-4 pb-4">
                                                    <i class="material-symbols-outlined text-lg">sports_and_outdoors</i>
                                                    <i class="material-symbols-outlined text-lg"></i>
                                                </div> -->
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="text-center text-sm pt-4" v-else>
                                    <span>Aucun terrain.</span>
                                </div>
                                <div class="text-center py-5">
                                    <a v-if="currentUser.role == 'owner'" href="my/establishment/facility" class="btn btn-primary btn-rounded text-sm py-2 px-3">
                                        Ajouter un terrain
                                    </a>
                                    <a v-else :href="`my/establishment/${this.id}/facility`" class="btn btn-primary btn-rounded text-sm py-2 px-3">
                                        Ajouter un terrain
                                    </a>
                                </div>
                            </div>
                            <div v-if="activeTab === 'business_hours'" class="tab-pane fade show active">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="d-flex flex-row align-items-center mb-2"
                                            v-for="businessDay in establishment.business_hours" :key="businessDay.day"
                                            style="min-height: 31px;">
                                            <span class="pl-0 text-left" style="width: 100px;">{{
                                                getDayNameInFrench(businessDay.day) }}</span>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    v-model="businessDay.is_active" :id="businessDay.day" />
                                                <label class="custom-control-label px-2" style="justify-content: left"
                                                    :for="businessDay.day">
                                                    <span v-if="!businessDay.is_active">Fermé</span>
                                                    <span v-else>Ouvert</span>
                                                </label>
                                            </div>
                                            <span class="px-2" v-if="businessDay.is_active">de</span>
                                            <div v-if="businessDay.is_active">
                                                <select class="custom-select custom-select-sm"
                                                    v-model="businessDay.open">
                                                    <option v-for="time in getDayHours()" :key="time" :value="time">
                                                        {{ time }}
                                                    </option>
                                                </select>
                                            </div>
                                            <span class="px-2" v-if="businessDay.is_active">à</span>
                                            <div v-if="businessDay.is_active">
                                                <select class="custom-select custom-select-sm"
                                                    v-model="businessDay.close">
                                                    <option v-for="time in getDayHours()" :key="time" :value="time">
                                                        {{ time }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-4">
                                        <div class="submit-section">
                                            <button type="submit" class="btn btn-primary btn-rounded text-sm" @click.prevent="saveBusinessHours">
                                                <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                                <label class="m-0 mx-1">Enregistrer</label>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activeTab === 'other_infos'" class="tab-pane fade show active">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label class="text-sm text-muted">Modalités de Paiement</label>
                                        <div class="form-inline">
                                            <div class="custom-control custom-checkbox mr-4">
                                                <input type="checkbox" class="custom-control-input" id="paymentCash"
                                                    v-model="payment_cash" :checked="isPaymentMethodChecked(0)"
                                                    @change="updatePaymentMethods(0)" />
                                                <label class="custom-control-label" for="paymentCash">Espèces</label>
                                            </div>
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="paymentCard"
                                                    v-model="payment_card" :checked="isPaymentMethodChecked(1)"
                                                    @change="updatePaymentMethods(1)" :disabled="true"/>
                                                <label class="custom-control-label" for="paymentCard">Carte
                                                    Crédit</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group card-label mb-3">
                                            <label>RIB</label>
                                            <input type="text" class="form-control" v-model="establishment.rib"
                                                required />
                                        </div>
                                    </div>
                                    <div v-if="currentUser.role === 'admin' || currentUser.role === 'owner'" class="col-md-6 mb-3">
                                        <div class="form-group card-label">
                                            <label>Frais</label>
                                            <input type="number" class="form-control" v-model.number="establishment.fee" :disabled="currentUser.role !== 'admin'" step="1" min="0" />
                                        </div>
                                    </div>
                                    <div v-if="currentUser.role === 'admin' || currentUser.role === 'owner'" class="col-md-6 mb-3">
                                        <div class="form-group card-label">
                                            <label>Unité de Frais</label>
                                            <select class="custom-select" v-model="establishment.fee_unit" :disabled="currentUser.role !== 'admin'">
                                                <option value="percentage">Pourcentage (%)</option>
                                                <option value="fixed">Montant fixe</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="text-sm text-muted">Services</label>
                                    </div>
                                    <div class="col-12 mt-4">
                                        <div class="submit-section">
                                            <button class="btn btn-primary btn-rounded text-sm" @click.prevent="saveOtherInfos">
                                                <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                                <label class="m-0 mx-1">Enregistrer</label>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div v-if="activeTab === 'photos'" class="tab-pane fade show active">
                                    Photos
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <layout-footer />
    </div>
</template>
<style>
.nav-tabs.nav-justified > li > a {
    width: max-content;
}
</style>
<script>
import { GoogleMap } from 'vue3-google-map'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";
import defaultImagePath from '@/assets/img/photo.png'

export default {
    components: {
        "vendor-sidebar": VendorSidebar,
        vSelect,
        GoogleMap
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
    },
    props: {
        id: {
            required: false
        }
    },
    data() {
        return {
            activeTab: 'infos',
            defaultImage: defaultImagePath,
            previewUrl: null,
            selectedFile: null,
            establishment: {
                business_name: '',
                logo_url: '',
                vat_id: '',
                description: '',
                delegation: '',
                address: '',
                business_hours: [],
                fee: 0,
                fee_unit: 'percentage'
            },
            facilities: [],
            mapCenter: { lat: 36.8065, lng: 10.1815 },
        }
    },
    mounted() {
        this.getEstablishment()
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0]
            if (file) {
                this.selectedFile = file
                this.previewUrl = URL.createObjectURL(file)
            }
        },
        getEstablishment() {
            const id = this.id ? this.id : ''
            api.get('/private/establishment/' + id)
                .then(response => {
                    const result = response.data
                    this.establishment = result
                    this.previewUrl = result.logo_url
                    this.mapCenter.lat = result.latitude
                    this.mapCenter.lng = result.longitude
                    this.parseBusinessHours()
                    this.getFacilities()
                })
        },
        getFacilities() {
            const establishment_api = (this.id) ? `/establishment/${this.id}` : ''
            api.get(`/private${establishment_api}/facilities`)
                .then(response => {
                    const result = response.data
                    this.facilities = result
                })
        },
        async saveInfos() {
            const formData = new FormData()
            formData.append('form_data', JSON.stringify(this.establishment))
            formData.append('logo', this.selectedFile)

            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.put('/private/establishment', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: "Les informations de l'établissement ont été mises à jour avec succès."
                    })
                    console.log('Infos updated successfully');
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
        async saveOtherInfos() {
            const otherInfos = {
                'id': this.establishment.id,
                'payment_methods': this.establishment.payment_methods,
                'rib': this.establishment.rib,
                'fee': this.establishment.fee,
                'fee_unit': this.establishment.fee_unit
            }
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.put('/private/establishment/other_infos', otherInfos)
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: "Les informations de l'établissement ont été mises à jour avec succès."
                    })
                    console.log('Other infos updated successfully');
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
        async saveBusinessHours() {
            const data = {
                id: this.establishment.id,
                business_hours: this.establishment.business_hours
            }
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.put('/private/establishment/business_hours', data)
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: "Les horaires de l'établissement ont été mises à jour avec succès."
                    })
                    console.log('Business hours updated successfully');
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
        parseBusinessHours() {
            const weekDays = [
                "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
            ];
            const working_hours = weekDays.map((day) => {
                let foundDay = {}
                if (this.establishment.business_hours)
                    foundDay = this.establishment.business_hours.find((hour) => hour.day === day);

                return {
                    day,
                    open: foundDay && foundDay.open ? foundDay.open : "00:00",
                    close: foundDay && foundDay.close ? foundDay.close : "00:00",
                    is_active: foundDay && foundDay.is_active ? foundDay.is_active : false,
                };
            });
            this.establishment.business_hours = working_hours;
        },
        getDayHours() {
            const hours = [];
            for (let i = 0; i < 24; i++) {
                const hour = i.toString().padStart(2, '0') + ":00";
                hours.push(hour);
                const hourHalf = i.toString().padStart(2, '0') + ":30";
                hours.push(hourHalf);
            }
            return hours;
        },
        getFeaturedImage(facility) {
            const featuredImage = facility.images.filter(img => img.role === 'featured')
            if (featuredImage.length > 0) return featuredImage[0]['thumb_medium_url']
            return null
        },
        getDayNameInFrench(dayName) {
            const referenceDays = {
                Sunday: 'Dimanche',
                Monday: 'Lundi',
                Tuesday: 'Mardi',
                Wednesday: 'Mercredi',
                Thursday: 'Jeudi',
                Friday: 'Vendredi',
                Saturday: 'Samedi'
            };
            return referenceDays[dayName]
        },
        isPaymentMethodChecked(paymentIndex) {
            return (this.establishment.payment_methods & (1 << paymentIndex)) !== 0;
        },
        updatePaymentMethods(paymentIndex) {
            // Use bitwise operations to update the bitmask:
            if (paymentIndex === 0) {
                // If checkbox 1 is checked, set bit 0, else clear it
                this.establishment.payment_methods = this.payment_cash
                    ? this.establishment.payment_methods | (1 << paymentIndex)
                    : this.establishment.payment_methods & ~(1 << paymentIndex);
            } else if (paymentIndex === 1) {
                // If checkbox 2 is checked, set bit 1, else clear it
                this.establishment.payment_methods = this.payment_card
                    ? this.establishment.payment_methods | (1 << paymentIndex)
                    : this.establishment.payment_methods & ~(1 << paymentIndex);
            }
        },
        async validateEstablishment() {
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.put(`/private/establishment/${this.establishment.id}/validate`)
                .then(response => {
                    this.establishment = response.data
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: "L'établissement a été validé avec succès."
                    })
                    console.log('Establishment validated successfully');
                }).catch(error => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: "Une erreur est survenue lors de la validation de l'établissement."
                    })
                    console.error('Error validating establishment:', error);
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
        async toggleEstablishmentStatus() {
            const data = {
                id: this.establishment.id,
                is_active: !this.establishment.is_active
            }
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.put('/private/establishment/toggle-status', data)
                .then(response => {
                    this.establishment.is_active = !this.establishment.is_active
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: this.establishment.is_active ? "L'établissement a été activé avec succès." : "L'établissement a été désactivé avec succès."
                    })
                    console.log('Establishment status toggled successfully');
                }).catch(error => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: "Une erreur est survenue lors du changement du statut de l'établissement."
                    })
                    console.error('Error toggling establishment status:', error);
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
    },
};
</script>
